import { render, staticRenderFns } from "./EditCompanyProfile.vue?vue&type=template&id=bbaebabe&"
import script from "./EditCompanyProfile.vue?vue&type=script&lang=js&"
export * from "./EditCompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditCompanyProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports